// S1 — Shopfloor onboarding. 8 steps on /shopfloorcontrol.
// State A (pre-worker-selection): steps 1-2 anchored on the worker-select link.
// Tour pauses after step 2 (TourRunner watches state.ShopFloorControl.currentWorker).
// State B (post-worker-selection): steps 3-8 anchored on task-card sections.
export default {
  key: 'S1',
  route: '/shopfloorcontrol',
  steps: [
    {
      id: 'identify',
      target: '[data-tour-id="shopfloor.worker-select"]',
      title: 'Identify Yourself',
      desc: 'Select your name from the list to start your shift.',
    },
    {
      id: 'barcode',
      target: '[data-tour-id="shopfloor.worker-select"]',
      title: 'Barcode Scanner',
      desc: 'You can also scan your personal barcode — the system will identify you automatically.',
    },
    {
      id: 'tasks',
      target: '[data-tour-id="shopfloor.task-list"]',
      title: 'Your Tasks',
      desc: 'These are your assigned tasks, ordered by priority. The most urgent appear first.',
    },
    {
      id: 'start-stop',
      target: '[data-tour-id="shopfloor.start-stop-btns"]',
      title: 'Start and Stop',
      desc: 'Press Start when you begin a task and Stop when you pause or finish. Time is tracked automatically.',
    },
    {
      id: 'counters',
      target: '[data-tour-id="shopfloor.counters"]',
      title: 'Report Progress',
      desc: 'Enter produced quantities and any scrap. The total counts are updated live.',
    },
    {
      id: 'docs',
      target: '[data-tour-id="shopfloor.documents"]',
      title: 'Documents and Drawings',
      desc: 'Tap a product or document link to open drawings and technical files.',
    },
    {
      id: 'note',
      target: '[data-tour-id="shopfloor.note-input"]',
      title: 'Add a Note',
      desc: 'Use the note field to flag anything important for the manager.',
    },
    {
      id: 'logout',
      target: '[data-tour-id="shopfloor.logout"]',
      title: 'Finish Your Shift',
      desc: 'When you are done, press Logout (top right) so the next worker can sign in.',
    },
  ],
}
